import axios from './axios';

export const getUsers = async (params = {}) => {
  return await axios.get('/api/v1/users', { params });
};

export const getUser = async (id) => {
  return await axios.get(`/api/v1/users/${id}`);
};

export const createUser = async (data) => {
  return await axios.post('/api/v1/users', data);
};

export const updateUser = async (id, data) => {
  return await axios.put(`/api/v1/users/${id}`, data);
};

export const deleteUser = async (id) => {
  return await axios.delete(`/api/v1/users/${id}`);
};

export const getRoles = async () => {
  return await axios.get('/api/v1/roles');
};

export const getPermissionsMatrix = async () => {
  return await axios.get('/api/v1/rbac/permissions-matrix');
};

export const updatePermissionsMatrix = async (data) => {
  return await axios.put('/api/v1/rbac/permissions-matrix', data);
};

export const createRole = async (data) => {
  return await axios.post('/api/v1/roles', data);
};

export const resetRolePermissions = async (roleId) => {
  return await axios.post(`/api/v1/roles/${roleId}/reset`);
};

export const resetUserPassword = async (userId, data) => {
  return await axios.post(`/api/v1/users/${userId}/reset-password`, data);
};

export const resendUserInvite = async (userId) => {
  return await axios.post(`/api/v1/users/${userId}/resend-invite`);
};
